<template>
  <el-dialog
    :title="$t('communityManage.editCommunity')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="editCommunityInfo" label-width="120px" :rules="rules" ref="editCommunityForm">
      <el-form-item :label="$t('communityManage.name')" prop="name">
        <el-input
          v-model="editCommunityInfo.name"
          :placeholder="$t('communityManage.namePlaceholder')"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('communityManage.address')" prop="address">
        <el-input
          v-model="editCommunityInfo.address"
          :placeholder="$t('communityManage.addressPlaceholder')"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('communityManage.nearbyLandmarks')" prop="nearbyLandmarks">
        <el-input
          v-model="editCommunityInfo.nearbyLandmarks"
          :placeholder="$t('communityManage.nearbyLandmarksPlaceholder')"
        ></el-input>
      </el-form-item>

      <template v-for="(item,index) in editCommunityInfo.attrs">
        <el-form-item
          :label="item.specName"
          :key="index"
          v-if="item.specType == '2233'"
        >
          <el-input
            v-model="item.value"
            :placeholder="item.specHoldplace"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="item.specName"
          :key="index"
          v-if="item.specType == '3344'"
        >
          <el-select
            v-model="item.value"
            :placeholder="item.specHoldplace"
            style="width: 100%"
          >
            <el-option
              v-for="value in item.values"
              :key="value.value"
              :label="value.valueName"
              :value="value.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editCommunity">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateCommunity, getAttrSpec, getAttrValue } from '@/api/common/communityManage/communityManageApi'

export default {
  name: 'EditCommunity',
  data() {
    return {
      dialogVisible: false,
      editCommunityInfo: {
        communityId: '',
        name: '',
        address: '',
        nearbyLandmarks: '',
        cityCode: '',
        mapX: '101.33',
        mapY: '101.33',
        attrs: []
      },
      rules: {
        name: [
          { required: true, message: this.$t('communityManage.nameRequired'), trigger: 'blur' },
          { min: 4, max: 20, message: this.$t('communityManage.nameLength'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('communityManage.addressRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('communityManage.addressMaxLength'), trigger: 'blur' }
        ],
        nearbyLandmarks: [
          { required: true, message: this.$t('communityManage.nearbyLandmarksRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('communityManage.nearbyLandmarksMaxLength'), trigger: 'blur' }
        ],
        communityId: [
          { required: true, message: this.$t('communityManage.communityIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(community) {
      this.dialogVisible = true
      this.refreshEditCommunityInfo()
      this.$nextTick(() => {
        this.$refs.editCommunityForm.resetFields()
        Object.assign(this.editCommunityInfo, community)

        if (Object.prototype.hasOwnProperty.call(community,'communityAttrDtos')) {
          const attrDtos = community.communityAttrDtos
          attrDtos.forEach(item => {
            this.editCommunityInfo.attrs.forEach(attrItem => {
              if (item.specCd == attrItem.specCd) {
                attrItem.attrId = item.attrId
                attrItem.value = item.value
              }
            })
          })
        }
      })
    },
    handleClose() {
      this.$refs.editCommunityForm.resetFields()
    },
    editCommunity() {
      this.$refs.editCommunityForm.validate(valid => {
        if (!valid) return
        
        updateCommunity(this.editCommunityInfo).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('saved')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          console.error('请求失败:', error)
          this.$message.error(this.$t('common.saveFailed'))
        })
      })
    },
    refreshEditCommunityInfo() {
      const attrs = this.editCommunityInfo.attrs
      this.editCommunityInfo = {
        communityId: '',
        name: '',
        address: '',
        nearbyLandmarks: '',
        cityCode: '',
        mapX: '101.33',
        mapY: '101.33',
        attrs: attrs
      }
    },
    _loadEditCommunityAttrSpec() {
      this.editCommunityInfo.attrs = []
      getAttrSpec('building_community_attr').then(data => {
        data.forEach(item => {
          item.value = ''
          item.values = []
          this._loadEditAttrValue(item.specCd, item.values)
          if (item.specShow == 'Y') {
            this.editCommunityInfo.attrs.push(item)
          }
        })
      })
    },
    _loadEditAttrValue(specCd, values) {
      getAttrValue(specCd).then(data => {
        data.forEach(item => {
          if (item.valueShow == 'Y') {
            values.push(item)
          }
        })
      })
    }
  },
  created() {
    this._loadEditCommunityAttrSpec()
  }
}
</script>

<style scoped>
.el-select {
  margin-right: 10px;
}
</style>